const config = {
  apiBaseUrl: import.meta.env.VITE_APP_API_BASE_URL || 'http://localhost:3000/api'
};

// console.log('API Base URL in config:', config.apiBaseUrl);
// console.log('NODE_ENV:', import.meta.env.MODE);

export default config;